<!--
    @修改人：黎柏祺
    @修改时间：2018-10-18
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
    @负责人: 谢汉
    @创建时间: 2018-01-24
    @版本:v1.0.13
    @描述: 灰度用户配置
    -->
<template>
  <div class="ABUserConfig__content">
    <div class="ABUserConfig__form">
      <el-form ref="form" :model="form" :inline="true" label-width="80">
        <el-form-item :label="$t('ABUserConfig.key')">
          <el-input v-model="form.userKey"></el-input>
        </el-form-item>
        <el-form-item :label="$t('ABUserConfig.user')">
          <el-input v-model="form.userName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="e_search" v-g-rac="gRac('ABUserConfig@search')">{{ $t('common.search') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="ABUserConfig__operation mb-base">
      <el-button type="primary" @click="e_create">{{ $t('ABUserConfig.userCreate') }}</el-button>
      <el-button type="primary" @click="e_release" v-g-rac="gRac('ABUserConfig@release')">{{ $t('ABUserConfig.userRelease') }}</el-button>
      <el-button type="primary" @click="e_allSwitch" v-g-rac="gRac('ABUserConfig@switch')">{{ $t('ABUserConfig.switch') }}</el-button>
      <el-button type="primary" @click="e_allRollBack" v-g-rac="gRac('ABUserConfig@rollBack')">{{ $t('ABUserConfig.rollBack') }}</el-button>
      <el-button type="primary" @click="downloadTemp" v-g-rac="gRac('ABUserConfig@download')">{{ $t('ABUserConfig.download') }}</el-button>
      <el-upload
        class="ABUserConfig__upload"
        ref="upload"
        :action="uploadUrl"
        :before-upload="checkUpload"
        :on-success="uploadSuccess"
        :show-file-list="showFileList"
        name="userInfoFile">
        <el-button type="primary" slot="trigger" v-g-rac="gRac('ABUserConfig@upload')">{{$t('ABUserConfig.upload')}}</el-button>
      </el-upload>
    </div>
    <div class="ABNodeConfig__table">
      <el-table-extend :data="tData" :head="tHead" :currentChange="tCurrentChange" :sizeChange="tSizeChange" border>
        <template slot="control-column" slot-scope="{data}">
          <el-table-extend-control :control="tableControl" :data="data" :label="$t('common.handle')">
          </el-table-extend-control>
        </template>
      </el-table-extend>
    </div>
    <dialog-form
      :title="$t('ABUserConfig.userCreate')" 
      :size="1" 
      :label-size="1" 
      :visible.sync="createFormVisible" 
      :model="createForm"
      :input-data="dialogData"
      :rules="createFormRules"
      :cancel-fun="e_cancel"
      :confirm-fun="isConfirmCreate">
    </dialog-form>
  </div>
</template>
<script>
  import ABUserConfig from '@/logic/continuousDelivery/ABUserConfigBiz.js'
  import dic from '@/components/mixins/dic'
  import rac from '@/plugins/rac-mixin.js'
  import table from '@/components/mixins/table'
  import dialogForm from '@/components/dialogForm'
  import validateConfig from '@/utils/validate'
  import TimeFormat from '@/utils/timeFormat.js'
  import { extend } from '@/utils/tool'
  import GlobalConfig from '@/utils/global-config'

  export default {
    mixins: [dic, table, rac],
    data () {
      const that = this
      return {
        tableData: {},
        form: {
          userKey: '',
          userName: ''
        },
        currentPage: 1,
        perPageCount: 10,
        tableControl: [{
          label: that.$t('common.delete'),
          callback: that.e_delete,
          rac: () => that.gRac('ABUserConfig@delete')
        }],
        createForm: {
          userKey: '',
          userName: '',
          descs: ''
        },
        createFormRules: {},
        createFormVisible: false,
        dialogData: [],
        uploadUrl: '/ops/grayreleased/userImport',
        showFileList: false
      }
    },
    methods: {
      e_init () {
        this.initTable()
        this.setDialogData()
        this.e_search()
      },
      setDialogData () {
        this.dialogData = [
          {
            label: this.$t('ABUserConfig.key'),
            key: 'userKey'
          },
          {
            label: this.$t('ABUserConfig.user'),
            key: 'userName'
          },
          {
            label: this.$t('ABUserConfig.desc'),
            key: 'descs',
            type: 'textarea'
          }
        ]
        const array = ['userKey', 'userName']
        array.map((item) => {
          this.createFormRules[item] = [{ ...validateConfig.common.notEmpty }]
        })
      },
      initTable () {
        this.tInitTable({
          lanKey: 'ABUserConfig.table',
          head: ['userKey', 'userName', 'descs', 'releaseTime'],
          requestFun: this.search
        })
      },
      search () {
        const reqData = extend(true, { ...this.tPageInfo }, this.form)
        ABUserConfig.findUser(reqData).then((data) => {
          data.dataList.forEach((item, index) => {
            item.releaseTime = TimeFormat.getFormatTime(item.releaseTime, 'yyyy-mm-dd hh-MM-ss')
          })
          this.tData = data
        })
      },
      e_search () {
        this.tResetPage()
        this.search()
      },
      e_delete (d) {
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          ABUserConfig.deleteUser({ id: d.id }).then(() => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            setTimeout(() => {
              this.e_search()
            }, 500)
          })
        }).catch(() => {})
      },
      e_create () {
        this.createFormVisible = true
      },
      e_release () {
        const that = this
        ABUserConfig.releaseUser().then(() => {
          that.$message({
            message: that.$t('common.success'),
            type: 'success'
          })
          setTimeout(() => {
            that.e_search()
          }, 500)
        })
      },
      e_allRollBack () {
        const that = this
        ABUserConfig.rollBack().then(() => {
          that.$message({
            message: that.$t('common.success'),
            type: 'success'
          })
          setTimeout(() => {
            that.e_search()
          }, 500)
        })
      },
      e_allSwitch () {
        const that = this
        ABUserConfig.allSwitch().then(() => {
          that.$message({
            message: that.$t('common.success'),
            type: 'success'
          })
          setTimeout(() => {
            that.e_search()
          }, 500)
        })
      },
      downloadTemp () {
        GlobalConfig.getConfig().then((data) => {
          window.open(`${data.crmHost}/htemp/resources/import_gray_released_user2_template.xls`)
        })
      },
      isConfirmCreate () {
        ABUserConfig.createUser(this.createForm).then((d) => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          setTimeout(() => {
            this.e_cancel()
            this.e_search()
          }, 500)
        })
      },
      e_cancel () {
        this.createFormVisible = false
        Object.keys(this.createForm).forEach((item) => {
          this.createForm[item] = ''
        })
      },
      checkUpload (file, fileList) {
        const reg = /^.*\.(?:xls|xlsx|XLS|XLSX)$/i
        if (!reg.test(file.name)) {
          this.$message({
            message: this.$t('ABUserConfig.uploadRule'),
            type: 'warning'
          })
          return false
        }
      },
      uploadSuccess (response, file, fileList) {
        if (response.resultCode === '00000000') {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
        } else {
          this.$message({
            message: response.resultDesc,
            type: 'warning'
          })
        }
      }
    },
    components: {
      dialogForm
    },
    mounted () {
      this.e_init()
    }
  }
</script>

<style>
  .ABUserConfig__upload {
      display: inline-block;
      margin-left: 8px;
  }
</style>